import React from "react"
import Typed from 'react-typed'
 
const Hero = () => {
  return (
    <div className="text-white align-top pt-16 bg-gradient-to-r from-inherit to-black">
      <div className="max-w-[800px] w-full h-fit mx-auto text-center flex flex-col justify-center">
        <p className="text-[rgb(97,198,44)] font-italic p-2 mb-2 text-4xl">Buscamos, Lavamos e Entregamos Na Sua Casa</p>
        <p className="text-white p-2 m-0 text-xl">Você gostaria de mais tempo para passar com amigos e família? A eLav busca as suas roupas em casa, lava e entrega. Tudo com muito cuidado e qualidade</p>
        <p className="text-white p-2 m-0 text-l text-opacity-80">Rua Teixeira Soares 138, Seminário, Curitiba</p>
        {/* <h1 className="md:text-7xl sm:text-6xl text-4xl font-bold md:py-6">Conheça nossos planos</h1> */}

        <div className="flex justify-center items-center">
          
          <button className="w-[300px] h-[50px] border border-[rgb(97,198,44)] rounded-xl border-3 font-medium mx-auto text-xl
            hover:text-black hover:bg-[rgb(97,198,44)] hover:scale-110 duration-300">
            <a 
              href="https://api.whatsapp.com/send/?phone=5541992636949&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+tirar+d%C3%BAvidas.&type=phone_number&app_absent=0"
              onClick={(e) => {
                e.preventDefault();
                window.gtag_report_conversion("https://api.whatsapp.com/send/?phone=5541992636949&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+tirar+d%C3%BAvidas.&type=phone_number&app_absent=0");
              }}
            >
              Entre em contato
            </a>
          </button>
        </div>

        {/* className="flex justify-center items-center */}
        <div className="mt-2 pb-16">
          {/* <p className="md:text-3xl sm:text-2xl text-xl font-bold">Trabalhamos com entrega</p> */}
          <Typed
            className="md:text-3xl sm:text-2xl text-xl font-bold py-4"
            strings={["Planos diversos", "Mais tempo para você", "Roupa suja nunca mais", "Tenha sempre roupas limpas e cheirosas", "Mantenha sua rotina sem preocupação"]}
            typeSpeed={30}
            backSpeed={60}
            loop 
          />
        </div>
        
      </div>
      <hr></hr>
    </div>
  )
}

export default Hero